import { MarkDetail, mark } from "../logger/mark";

let markId = 0;
export const loggingFetch: WindowOrWorkerGlobalScope["fetch"] = async (input, init) => {
  const { method, url } =
    typeof input === "string"
      ? {
          method: init?.method,
          url: input,
        }
      : {
          method: input.method,
          url: input.url,
        };
  const name = `api-${markId++}-${url}`;
  mark({ logData: { url }, name });
  const response = await window.fetch(input, init);
  const { status } = response;
  let logData: MarkDetail["logData"];
  if (!response.ok) {
    const text = await response.clone().text();
    try {
      logData = { request: { method }, response: { data: JSON.parse(text), status } };
    } catch (error) {
      logData = { request: { method }, response: { status } };
    }
  } else {
    logData = { request: { method }, response: { status } };
  }
  mark({ end: true, logData, name });
  return response;
};
